export enum AppRoute {
  main = '/',
  checkout = '/checkout',
  nameCheckCheckout = '/name-check-checkout',
  errorPage = '/errorPage',
}
